import http from "../../services/httpService";
import { apiUrl } from "../../config.json";
import qs from "qs";

const apiEndpoint = apiUrl + "token";
const tokenKey = "CokeAdminToken";

http.setToken(getToken());

export async function login(username, password, grant_type = "password") {
  const { data } = await http.post(
    apiEndpoint,
    qs.stringify({
      grant_type: grant_type,
      username: username,
      password: password
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }
  );
  const adminData = { fullName: data.fullName, role: data.role , profileImage : data.image };
  localStorage.setItem(tokenKey, data.access_token);
  localStorage.setItem("CokeAdminData", JSON.stringify(adminData));
  localStorage.setItem("CokeAdminRole", data.role);
  http.setToken(getToken());
}

export function checkLogin() {
  try {
    const data = localStorage.getItem(tokenKey);
    return data;
  } catch (ex) {
    return null;
  }
}

export function loginWithToken(token) {
  localStorage.setItem(tokenKey, token);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
  try {
    const data = JSON.parse(localStorage.getItem("CokeAdminData"));
    return data;
  } catch (ex) {
    return null;
  }
}


export function getToken() {
  return localStorage.getItem(tokenKey);
}

export default {
  login,
  loginWithToken,
  logout,
  getToken,
  getCurrentUser,
  checkLogin
};
